(function() {
    var searchInput = 'input[name="searchTerm"]',
        quickSearchResults = '[data-trade-in-quicksearch-list]',
        quickSearchResultsContainer = '[data-trade-in-search-results]',
        promise = null,
        QuickSearchException = {
            name: 'quicksearch error',
            level: 'non-blocker',
            message: 'Couldn\'t find any matching handsets',
            get htmlMessage() {
                return '<li>' + this.message + '</li>';
            }
        },
        searchForm = '[data-trade-in-search-form]',
        searchProduct = '[data-trade-in-search-product]',
        searchValue = '[data-search-value]',
        errorContainer = '[data-micro-trade-in-error]',
        errorContent = errorContainer + ' [data-message]',
        errorTimeout = 3000,
        getQuoteButton = '[data-get-quote-button]';

    var onSearchKeyPress = function(e) {
        var keyCode = e.which,
            isEnter = keyCode === 13;
        if (isEnter) {
            var $thisSearchSuggest = $(searchInput + ':focus').closest('form').next(quickSearchResultsContainer).find(searchValue),
                $liSelected = $thisSearchSuggest.filter('.bg-primary').last();
            if ($liSelected.length) {
                $liSelected.click();
                return false;
            }
        }
    };

    var onSearchKeyDown = function(e) {
        var keyCode = e.which,
            isEscape = keyCode === 27;
        if (isEscape) {
            closeSearchResults();
        }
    };

    var onSearchInputChange = function(e) {
        var keyCode = e.which,
            isArrowDown = keyCode === 40,
            isArrowUp = keyCode === 38,
            isEnter = keyCode === 13,
            isEscape = keyCode === 27;

        if (!isEnter && !isEscape) {
            if (isArrowDown || isArrowUp) {
                var $thisSearchSuggest = $(searchInput + ':focus').closest('form').next(quickSearchResultsContainer).find(searchValue),
                    $liSelected = $thisSearchSuggest.filter('.bg-primary').last(),
                    $nextLi;
                if ($liSelected) {
                    $thisSearchSuggest.removeClass('bg-primary');
                    $nextLi = isArrowDown ? $liSelected.next() : $liSelected.prev();
                    if ($nextLi.length > 0) {
                        $nextLi.addClass('bg-primary');
                    } else {
                        isArrowDown ? $thisSearchSuggest.eq(0).addClass('bg-primary') : $thisSearchSuggest.last().addClass('bg-primary');
                    }
                } else {
                    isArrowDown ? $thisSearchSuggest.eq(0).addClass('bg-primary') : $thisSearchSuggest.last().addClass('bg-primary');
                }
            } else {
                if ($(searchInput).val().length < 3) {
                    return;
                }
                $(quickSearchResultsContainer).removeClass('hide');
                $(quickSearchResults).empty();
                $(quickSearchResults).append('<li>Searching...</li>');
                var currentText = $(this).val();
                if (promise) {
                    promise.abort();
                }
                promise = $.ajax({
                    url: $(quickSearchResults).attr('data-trade-in-autocomplete-url'),
                    type: 'POST',
                    data: {
                        'search': currentText
                    },
                    success: quickSearchSuccess,
                    error: quickSearchError
                });
            }
        }
    };

    var onSearchResultClick = function(e) {
        var path = $(quickSearchResults).attr('data-trade-in-product-details-path') + '/' + e.data.modelId;
        isTradeInMicro()
            ? fetchNextMicroStep(e, path, {
                'ab': $('[data-micro-trade-in-component-ab]').length
            })
            : window.location = path;
        closeSearchResults();
    };

    var quickSearchSuccess = function(data) {
        var results = data.results,
            $quickSearchResults = $(quickSearchResults);

        $quickSearchResults.empty();
        if (results.length === 0) {
            $quickSearchResults.empty();
            $quickSearchResults.append('<li>No handset found</li>');
        }

        results.forEach(function(item) {
            $quickSearchResults.append('<li data-search-value role="button">' + item.title + '</li>');
            var $searchResult = $(searchValue + ':last-child');
            $searchResult.on('click', {
                modelId: item.modelId
            }, onSearchResultClick);
        });

        $quickSearchResults.find('li').on('click', function(e) {
            e.stopPropagation();
        });
        return false;
    };

    var quickSearchError = function() {
        try {
            if (promise) {
                return;
            }
            throw QuickSearchException;
        } catch (e) {
            handleQuickSearchException(e);
        }
    };

    var handleQuickSearchException = function(e) {
        var $quickSearchResults = $(quickSearchResults);

        if (e === QuickSearchException) {
            if ($quickSearchResults.hasClass('hide')) {
                $quickSearchResults.removeClass('hide');
            }
            $quickSearchResults.empty();
            $quickSearchResults.append(e.htmlMessage);
        }
    };

    var onMouseEnterSearchResult = function() {
        $(this).addClass('bg-primary');
    };

    var onMouseLeaveSearchResult = function() {
        $(searchValue).removeClass('bg-primary');
    };

    var isTradeInMicro = function() {
        return $('[data-micro-trade-in-component]').length > 0 || $('[data-micro-trade-in-component-ab]').length > 0;
    };

    var displayError = function(error) {
        $(errorContent).html(error ? error : 'A problem occurred - please try again later.');
        $(errorContainer).slideDown().delay(errorTimeout).slideUp();
    };

    var fetchNextMicroStep = function(event, endpoint, data) {
        if (!isTradeInMicro()) {
            return true;
        }

        event.preventDefault();
        $.ajax({
            url: endpoint,
            type: 'GET',
            data: data,
            success: function(response) {
                response = JSON.parse(response);
                response.success
                    ? $('[data-micro-trade-in-inner]').html(response.content)
                    : displayError(response.error);
            },
            error: displayError
        });
    };

    var closeSearchResults = function() {
        $(quickSearchResultsContainer).addClass('hide');
    };

    var onFormSubmit = function(event) {
        fetchNextMicroStep(event, $(searchForm).attr('action'), {
            'searchTerm': $(searchInput).val()
        });
        closeSearchResults();
    };

    var onSearchedProductClick = function(event) {
        fetchNextMicroStep(event, $(this).attr('href'), {
            'ab': $('[data-micro-trade-in-component-ab]').length
        });
        closeSearchResults();
    };

    var init = function() {
        $(document)
            .on('click', function() {
                var $quickSearchResultsContainer = $(quickSearchResultsContainer);
                if (!$quickSearchResultsContainer.hasClass('hide')) {
                    $quickSearchResultsContainer.addClass('hide');
                    $(quickSearchResults).empty();
                }
            })
            .on('keypress', searchInput, onSearchKeyPress)
            .on('keydown', searchInput, onSearchKeyDown)
            .on('keyup click', searchInput, onSearchInputChange)
            .on({
                mouseenter: onMouseEnterSearchResult,
                mouseleave: onMouseLeaveSearchResult
            }, quickSearchResults + ' *')
            .on('submit', searchForm, onFormSubmit)
            .on('click', getQuoteButton, onFormSubmit);

        $('body').on('click', searchProduct, onSearchedProductClick);
    };
    init();
})($);
